module.exports = __webpack_public_path__ + "static/media/URBEX_HORIZONTAL_BLUE.9080e1e6.png";